// src/api/params-api.js
import { gql } from '@apollo/client';
import client from './apollo-client';

// GraphQL Queries
export const GET_PARAMS = gql`
  query GetParams {
    params {
      id
      nom
      seuil
      numberOfDays
      organismeId
      organisme {
        id
        nomOrganisme
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_PARAM = gql`
  query GetParam($id: ID!) {
    param(id: $id) {
      id
      nom
      seuil
      numberOfDays
      organismeId
      organisme {
        id
        nomOrganisme
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_ORGANISMES_PAIEMENT = gql`
  query GetOrganismesPaiement {
    organismesPaiement {
      id
      nomOrganisme
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      defaultOrganisme
      createdAt
      updatedAt
    }
  }
`;

// GraphQL Mutations
export const CREATE_PARAM = gql`
  mutation CreateParam($createParamInput: CreateParamInput!) {
    createParam(createParamInput: $createParamInput) {
      id
      nom
      seuil
      numberOfDays
      organismeId
      organisme {
        id
        nomOrganisme
      }
    }
  }
`;

export const UPDATE_PARAM = gql`
  mutation UpdateParam($updateParamInput: UpdateParamInput!) {
    updateParam(updateParamInput: $updateParamInput) {
      id
      nom
      seuil
      numberOfDays
      organismeId
      organisme {
        id
        nomOrganisme
      }
    }
  }
`;

export const DELETE_PARAM = gql`
  mutation DeleteParam($id: ID!) {
    removeParam(id: $id)
  }
`;

// Params API functions
export const paramsApi = {
  getParams: async () => {
    try {
      const { data } = await client.query({
        query: GET_PARAMS,
        fetchPolicy: 'network-only'
      });
      return data.params;
    } catch (error) {
      console.error('Get params error:', error);
      throw error;
    }
  },

  getParam: async (id) => {
    try {
      const { data } = await client.query({
        query: GET_PARAM,
        variables: { id },
        fetchPolicy: 'network-only'
      });
      return data.param;
    } catch (error) {
      console.error(`Get param ${id} error:`, error);
      throw error;
    }
  },

  getOrganismesPaiement: async () => {
    try {
      const { data } = await client.query({
        query: GET_ORGANISMES_PAIEMENT,
        fetchPolicy: 'network-only'
      });
      return data.organismesPaiement;
    } catch (error) {
      console.error('Get organismes paiement error:', error);
      throw error;
    }
  },

  createParam: async (paramData) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_PARAM,
        variables: { createParamInput: paramData },
        refetchQueries: [{ query: GET_PARAMS }]
      });
      return data.createParam;
    } catch (error) {
      console.error('Create param error:', error);
      throw error;
    }
  },

  updateParam: async (paramData) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_PARAM,
        variables: { updateParamInput: paramData },
        refetchQueries: [{ query: GET_PARAMS }]
      });
      return data.updateParam;
    } catch (error) {
      console.error(`Update param ${paramData.id} error:`, error);
      throw error;
    }
  },

  deleteParam: async (id) => {
    try {
      const { data } = await client.mutate({
        mutation: DELETE_PARAM,
        variables: { id },
        refetchQueries: [{ query: GET_PARAMS }]
      });
      return data.removeParam;
    } catch (error) {
      console.error(`Delete param ${id} error:`, error);
      throw error;
    }
  }
};